import { useEffect, useState } from 'react';
import { useLocation } from 'react-router';
import { isAbortError } from './api';
import { useAdmin } from './context';

/**
 * The caller's Inbox count for the Tickets badge (the queue's counts.inbox), read once per page Trace Admin shows, so
 * opening a ticket (which marks it read) or triaging one is reflected on the next page. Only for staff who read
 * tickets; a failed read shows no badge rather than an error (the Tickets page itself says what went wrong).
 */
export function useTicketInboxCount(enabled: boolean): number {
  const { api } = useAdmin();
  const { pathname } = useLocation();
  const [count, setCount] = useState(0);
  useEffect(() => {
    if (!enabled) {
      setCount(0);
      return;
    }
    const controller = new AbortController();
    // limit 1: only the counts matter here, not the rows.
    api.listTicketQueue({ view: 'inbox', limit: 1 }, controller.signal).then(
      (answer) => {
        if (!controller.signal.aborted) setCount(answer.counts.inbox);
      },
      (error: unknown) => {
        if (controller.signal.aborted || isAbortError(error)) return;
        setCount(0);
      },
    );
    return () => controller.abort();
  }, [api, enabled, pathname]);
  return count;
}
